export default function TargetsTable({ fundraiserDetails }) {
  const targets = fundraiserDetails?.target?.targets || [];

  if (!targets.length) {
    return <div>No targets available.</div>;
  }

  // Separate targets by status
  const latest = targets.find((t) => t.status === true);
  const previous = targets.filter((t) => t.status !== true);

  // Format amount to something like "50.00M"
  const formatAmount = (amount) => {
    if (!amount) return "0.00";
    const million = amount / 1_000_000;
    return `${million.toFixed(2)}M`;
  };

  // Calculate duration string from createdAt and duration string (e.g. "1 Month")
  const getDurationText = (createdAt, durationStr = "1 Month") => {
    const start = new Date(createdAt);
    const startDate = new Intl.DateTimeFormat("en", { day: "numeric", month: "short" }).format(start);

    let end = new Date(start);
    switch (durationStr) {
      case "3 Months":
        end.setMonth(end.getMonth() + 3);
        break;
      case "6 Months":
        end.setMonth(end.getMonth() + 6);
        break;
      default:
        end.setMonth(end.getMonth() + 1); // Default to 1 Month
    }

    end.setDate(end.getDate() - 1); // Inclusive range
    const endDate = new Intl.DateTimeFormat("en", { day: "numeric", month: "short" }).format(end);

    return `${startDate} - ${endDate}`;
  };

  const renderRow = (label, duration, targetAmount, achievedAmount) => (
    <div
      key={`${label}-${duration}`}
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        padding: "8px 0",
      }}
    >
      <div style={{ color: "#8C8C8C", fontSize: "13px" }}>{label}</div>
      <div style={{ color: "#8C8C8C", fontSize: "13px" }}>{duration}</div>
      <div style={{ color: "#8C8C8C", fontSize: "13px" }}>{formatAmount(targetAmount)}</div>
      <div style={{ color: "#8C8C8C", fontSize: "13px" }}>{formatAmount(achievedAmount)}</div>
    </div>
  );

  return (
    <div
      style={{
        borderRadius: "12px",
        border: "1px solid #00000029",
        padding: "20px",
        textAlign: "left",
        width: "100%",
        maxHeight: "200px",
        overflowY: "auto",
        scrollbarWidth: "none",
      }}
    >
      {/* Table Header */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          marginBottom: "10px",
        }}
      >
        <div style={{ fontWeight: 500, color: "black", fontSize: "14px" }}>Duration Type</div>
        <div style={{ fontWeight: 500, color: "black", fontSize: "14px" }}>Duration</div>
        <div style={{ fontWeight: 500, color: "black", fontSize: "14px" }}>Target</div>
        <div style={{ fontWeight: 500, color: "black", fontSize: "14px" }}>Achieved</div>
      </div>

      {/* Latest Target Row or fallback */}
      {latest ? (
        renderRow(
          latest?.duration,
          getDurationText(latest?.createdAt, latest?.duration),
          latest?.targetAmount,
          latest?.achievedAmount
        )
      ) : (
        <div style={{ color: "#8C8C8C", fontSize: "13px", padding: "8px 0" }}>No Current target exist</div>
      )}

      {/* Previous Targets */}
      {previous.length > 0 && (
        <div style={{ padding: "10px 0" }}>
          <div style={{ fontWeight: 500, color: "black", fontSize: "14px" }}>Previous</div>
        </div>
      )}
      {previous.map((item, index) =>
        renderRow(
          item?.duration,
          getDurationText(item?.createdAt, item?.duration),
          item?.lastTargetAmount,
          item?.lastAchievedAmount
        )
      )}
    </div>
  );
}
